import { useState } from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { useTranslation } from 'react-i18next';
import backIcon from '@/assets/chevron_left.svg';
import Button from './Button';
import Checkbox from './Checkbox';

const ReportDialog = ({ 
  isOpen, 
  onOpenChange, 
  onConfirm
}) => {
  const { t } = useTranslation();
  const [selectedOption, setSelectedOption] = useState(0);
  const [showConfirmView, setShowConfirmView] = useState(false);

  const reportOptions = [
    { id: 1, label: t('report.option1') },
    { id: 2, label: t('report.option2') },
    { id: 3, label: t('report.option3') },
    { id: 4, label: t('report.option4') },
    { id: 5, label: t('report.option5') },
    { id: 6, label: t('report.option6') }
  ];

  const handleInitialConfirm = () => {
    setShowConfirmView(true);
  };

  const handleBack = () => {
    setShowConfirmView(false);
  };

  const handleFinalConfirm = () => {
    onConfirm(selectedOption);
    onOpenChange(false);
    setShowConfirmView(false);
  };

  const handleClose = () => {
    onOpenChange(false);
    setShowConfirmView(false);
  };

  return (
    <Dialog.Root open={isOpen} onOpenChange={handleClose}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-black/50 z-50" />
        <Dialog.Content className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[400px] bg-white rounded-xl flex-col justify-start items-center inline-flex overflow-hidden z-50">
          {!showConfirmView ? (
            // Initial view with options
            <>
              <div className="self-stretch px-6 pt-8 pb-6 flex flex-col justify-start items-center gap-4">
                <Dialog.Title className="self-stretch text-center">
                  <span className="text-[#ff5501] text-lg font-bold">{t('report.title_highlight')}</span>
                  <span className="text-[#111111] text-lg font-bold">{t('report.title_main')}</span>
                </Dialog.Title>
                
                <div className="self-stretch flex flex-col justify-start items-start">
                  {reportOptions.map((option) => (
                    <div 
                      key={option.id}
                      className="self-stretch h-12 relative border-b border-[#eeeeee] flex items-center"
                      onClick={() => setSelectedOption(option.id)}
                    >
                      <Checkbox 
                        checked={selectedOption === option.id}
                        onCheckedChange={() => setSelectedOption(option.id)}
                      />
                      <div className="ml-4 text-black text-base font-normal leading-normal">
                        {option.label}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              
              <div className="self-stretch px-6 pb-6 bg-white flex flex-col justify-center items-center gap-6">
                <div className="self-stretch inline-flex justify-start items-center gap-3">
                  <Button 
                    variant="default" 
                    size="l" 
                    className="flex-1"
                    onClick={handleClose}
                  >
                    {t('report.cancel')}
                  </Button>
                  <Button 
                    variant="primary" 
                    size="l" 
                    className="flex-1"
                    onClick={handleInitialConfirm}
                    disabled={!selectedOption}
                  >
                    {t('report.confirm')}
                  </Button>
                </div>
              </div>
            </>
          ) : (
            // Confirmation view
            <>
              <div className="self-stretch px-6 pt-8 pb-6 flex flex-col justify-start items-center gap-4">
                <div className="self-stretch flex items-center gap-2">
                  <button 
                    onClick={handleBack}
                    className="w-4 h-4"
                  >
                      <img src={backIcon} alt='back' className='w-4 h-4'/>
                  </button>
                  <div className="text-center justify-start text-[#111111] text-lg font-bold leading-[27px]">
                    {t('report.confirm_view.title')}
                  </div>
                </div>
                <div className="self-stretch justify-center text-black text-base font-normal leading-normal">
                  {t('report.confirm_view.description')}
                </div>
              </div>
              
              <div className="self-stretch px-6 pb-6 bg-white flex flex-col justify-center items-center gap-6">
                <div className="self-stretch inline-flex justify-start items-center gap-3">
                  <Button 
                    variant="default" 
                    size="l" 
                    className="flex-1"
                    onClick={handleClose}
                  >
                    {t('report.cancel')}
                  </Button>
                  <Button 
                    variant="primary" 
                    size="l" 
                    className="flex-1"
                    onClick={handleFinalConfirm}
                  >
                    {t('report.confirm_view.confirm')}
                  </Button>
                </div>
              </div>
            </>
          )}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default ReportDialog; 